import useUserRole from "../../hooks/useUserRole"
import CoachDropdown from "../../pages/clients/CoachDropdown"
import ProfileDropdown from "../profileDropdown/ProfileDropdown"

const ChannelHeader = () => {
  const { isAdmin, isSupervisor } = useUserRole()

  if (isAdmin || isSupervisor) {
    return (
      <div className="min-h-[56px] w-full p-3 border-b border-borderPrimary">
        <CoachDropdown />
      </div>
    )
  } else
    return (
      <div className="min-h-[56px] w-full p-4 border-b border-borderPrimary">
        <ProfileDropdown />
      </div>
    )
}

export default ChannelHeader
